export default __webpack_public_path__ + "static/media/trout.a34efc00.jpg";